import React, {useState, useEffect} from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import Client from './client';
import AdminRedirect from './AdminRedirect';
import NotFound from './client/pages/NotFound';
import './App.css';

function App() {
  const [isLoaded, setIsloaded] = useState(false);
  const hideLoadScreen = () => {
    setIsloaded(true);
  }
  useEffect(() => {
    document.querySelector("body").style.overflowY = "hidden";
    window.onload = () => {
      hideLoadScreen();
      document.querySelector("body").style.overflowY = "";
    }
  }, []);
  
  const bodyStyles = {
    height: `${isLoaded ? "auto" : '100vh'}`
  };
  const childStyles = {
    display: `${isLoaded ? "none" : "flex"}`, 
    justifyContent: "center", 
    alignItems: "center", 
    width: "100vw", 
    height: '100%', 
    background: "#fff", 
    position: "absolute", 
    top: "0", 
    left: "0", 
    zIndex: "9999"
  };

  return (
    <div style = {bodyStyles}>
      <div style = {childStyles}>
        <img src = "/uploads/images/settings/svgviewer-output.svg" />
      </div>
      <BrowserRouter>
        <Switch>
          <Route path="/admin" component={AdminRedirect} />
          <Route exact path="/not-found" component={NotFound} />
          <Route component={Client} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
